import React from 'react'
import PageTitle from '../../components/PageTitle'
import azir_khattak from '../../assets/images/azir_khattak.jpg'
import shazeb_khattak from '../../assets/images/shazeb_khattak.jpeg'
import toheed_ahamad_khattak from '../../assets/images/toheed_ahamad_khattak.jpeg'
import abul_hassan from '../../assets/images/Abul_Hassan.png'

const Team = () => {
  return (
    <>
      <PageTitle title="Meet Our Expert" />
      {/* Team area start here */}
      <section className="team-section pt-120 pb-120">
        <div
          className="team-shape wow slideInLeft"
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          <img
            className="sway__animation"
            src="images/shape/team-shape.png"
            alt="Image"
          />
        </div>
        <div className="container">
          <div className="row g-4">
            <div
              className="col-md-6 col-xl-3 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <div className="team-block">
                <div className="inner-box">
                  <figure className="image">
                    <img src={azir_khattak} alt="Image" />
                  </figure>
                  <div className="socials d-none">
                    <i className="fa-solid fa-plus" />
                    <ul>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-linkedin-in" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-behance" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="content-box">
                    <h4 className="title">
                      <a href="page-team-details.html">Azhar Mahmood</a>
                    </h4>
                    <p className="sub-title">CEO</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-3 wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="team-block">
                <div className="inner-box">
                  <figure className="image">
                    <img src={shazeb_khattak} alt="Image" />
                  </figure>
                  <div className="socials d-none">
                    <i className="fa-solid fa-plus" />
                    <ul>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-linkedin-in" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-behance" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="content-box">
                    <h4 className="title">
                      <a href="page-team-details.html">Shahzeb Khattak</a>
                    </h4>
                    <p className="sub-title">Manager</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-3 wow fadeInUp"
              data-wow-delay="400ms"
              data-wow-duration="1500ms"
            >
              <div className="team-block">
                <div className="inner-box">
                  <figure className="image">
                    <img src={toheed_ahamad_khattak} alt="Image" />
                  </figure>
                  <div className="socials d-none">
                    <i className="fa-solid fa-plus" />
                    <ul>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-linkedin-in" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-behance" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="content-box">
                    <h4 className="title">
                      <a href="page-team-details.html">Toheed Ahamad</a>
                    </h4>
                    <p className="sub-title">HSE Engineer</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-3 wow fadeInUp"
              data-wow-delay="600ms"
              data-wow-duration="1500ms"
            >
              <div className="team-block">
                <div className="inner-box">
                  <figure className="image">
                    <img src={abul_hassan} alt="Image" />
                  </figure>
                  <div className="socials d-none">
                    <i className="fa-solid fa-plus" />
                    <ul>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-linkedin-in" />
                        </a>
                      </li>
                      <li>
                        <a href="#0">
                          <i className="fa-brands fa-behance" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="content-box">
                    <h4 className="title">
                      <a href="page-team-details.html">Abul Hassan</a>
                    </h4>
                    <p className="sub-title">Full Stack Developer</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Team area end here */}
    </>
  );
}

export default Team